import TourTypes from './types';

const INITIAL_STATE = {
  run: false,
  stepIndex: 0,
};

function tourReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case TourTypes.SET_TOUR_RUN:
      return {
        ...state,
        run: payload,
      };
    case TourTypes.SET_TOUR_INDEX:
      return {
        ...state,
        stepIndex: payload,
      };
    default:
      return state;
  }
}

export default tourReducer;
